import IServiceConfig from './IServiceConfig'

const DebugConfig: IServiceConfig = {
  BaseUrl: 'https://localhost:44378'
  //BaseUrl: 'http://localhost:81'
  //BaseUrl: 'http://cms.superdopey.nl'
}

export default DebugConfig
